import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { motion } from 'framer-motion';
import { ActionsProvider } from '../../../useLlm/useActions.js';
import { useLlm } from '../../../useLlm/useLlm.js';
import { Portals } from '../Portals/portals.js';
import style from './page-main.module.scss.js';

const PageMain = () => {
  const {
    PageIntro,
    PageThread,
    PagePrompt
  } = useLlm(state => state.components);
  const message = useLlm(state => state.message);
  const streaming = useLlm(state => state.streaming);
  const reveal = {
    hidden: {
      opacity: 0,
      scale: .98
    },
    show: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: .3
      }
    },
    exit: {
      opacity: 0,
      transition: {
        duration: .3,
        delay: .3
      }
    }
  };
  const classNames = getClassNames(style.main);
  return jsx(motion.div, {
    className: classNames,
    variants: reveal,
    initial: "hidden",
    animate: "show",
    exit: "exit",
    "data-lenis-prevent": true,
    children: jsxs(ActionsProvider, {
      children: [jsx(Portals, {
        children: streaming || message ? jsx(PageThread, {}) : jsx(PageIntro, {})
      }), streaming || message ? jsx(PagePrompt, {}) : jsx(Fragment, {})]
    })
  }, "page-main-container");
};

export { PageMain };
//# sourceMappingURL=page-main.js.map
